import React, { useContext } from "react";

//material ui
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ClusterViewDesktopRow from "./ClusterViewDesktopRow";
import Paper from "@material-ui/core/Paper";

//global state
import { StateContext } from "../../AppStateContext";

//styling
import "./clusterRow.css";

const ClustersViewDesktop = ({ headers, clusters, setClusters }) => {
  //use global state
  const state = useContext(StateContext);

  const useStyles = makeStyles({
    root: {
      background: "transparent",
      width: "100%",
      borderBottom: state.theme === "dark" ? "none" : "#ababab 1px solid",
      boxShadow:
        state.theme === "dark"
          ? "1px 1px 3px #213957"
          : "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    },
  });

  const classes = useStyles();

  return (
    <div className="__clusterRowInfo">
      <h3
        style={{
          color: state.theme === "dark" ? "#fff" : "#00152b",
        }}
      >
        Weaviate Clusters
      </h3>
      <Paper elevation={4} className={classes.root}>
        <TableContainer className={classes.container}>
          <Table className={classes.table} aria-label="Weaviate Clusters table">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                {headers.map((header, idx) => (
                  <TableCell
                    key={idx}
                    style={{
                      fontFamily: '"Alegreya Sans", sans-serif',
                      color: state.theme === "dark" ? "#fff" : "#00152b",
                      fontWeight: "bolder",

                      borderBottom:
                        state.theme === "dark"
                          ? "1px solid #122742"
                          : "1px solid #eaeaea",
                    }}
                    align={header.align}
                  >
                    {header.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {clusters && clusters.data.clusterIDs
                ? clusters.data.clusterIDs.map((cluster, idx) => (
                    <ClusterViewDesktopRow
                      key={cluster}
                      cluster={cluster}
                      clusters={clusters}
                      setClusters={setClusters}
                    />
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default ClustersViewDesktop;
